import React, { useState } from 'react';
import { OrderView } from './order/OrderView';
import CreditCheckView from './credit_check/CreditCheckView';
import LoginView from './login/LoginView';
import { getAccessToken } from '../backend/credentials';
import Notification from './core/notification';
import { SalesContext } from '../SalesContext';
import { Agreement } from '../models/Agreement';
import CreditCheckResult from '../models/CreditCheckResult';
import { ViewNavigation } from './core/view_navigation';
import { DocumentTitle } from './core/document_title';
import { AppConfig, defaultConfig } from '../config';
import EnvironmentIndicator from './core/environment_indicator';
import { DemoIndicator } from './core/demo_indicator';
import { ArchiveReferrer } from './archive/ArchiveReferrer';
import Bundle from '../models/Bundle';
import { AgreementMetadata } from '../models/AgreementMetadata';
import { TeamGatekeeper } from './team_gatekeeper';
import { useDefaultDate } from './agreement/sign_agreement/hooks';
import Product from '../models/Product';
import DemoSwitch from './demo/DemoSwitch';

const MainRouter: React.FC = () => {
  const [userToken, setUserToken] = useState(getAccessToken());
  const [orderIds, setOrderIds] = useState<string[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [creditCheckResult, setCreditCheckResult] = useState<CreditCheckResult>(null);
  const [agreementMeta, setAgreementMeta] = useState<AgreementMetadata>(null);
  const [agreement, setAgreement] = useState<Agreement>(null);
  const [config, setConfig] = useState<AppConfig>(defaultConfig);
  const [bundles, setBundles] = useState<Bundle[]>([]);
  const [qcRecording, setQcRecording] = useState<Blob>(null);
  const [offerSignatureUri, setOfferSignatureUri] = useState<string>("");
  const [offerUri, setOfferUri] = useState<string>("");
  const [isDemo, setDemo] = useState<boolean>(false);
  const [monthlyPaymentTotal, setMonthlyPaymentTotal] = useState<number>(0);

  const [nonce, setNonce] = useState(Date.now());

  function resetViews() {
    setNonce(Date.now());
  }

  return (
    <SalesContext.Provider
      value={{
        config,
        setConfig: cfg => {
          setConfig(cfg);
          localStorage.setItem('fjallkraft_logo', JSON.stringify({ ...cfg, demo: undefined }));
        },
        isDemo,
        orderIds,
        monthlyPaymentTotal,
        userToken,
        agreement,
        agreementMeta,
        creditCheckResult,
        bundles,
        products,
        qcRecording,
        offerSignatureUri,
        offerUri,
        setOrderIds,
        setUserToken,
        setAgreement,
        setAgreementMeta,
        setCreditCheckResult,
        setBundles,
        setProducts,
        setQcRecording,
        setMonthlyPaymentTotal,
        setOfferSignatureUri,
        setOfferUri,
        setDemo
      }}>
      <div key={nonce}>
        {
          userToken ? (
            <TeamGatekeeper>
              <LoginView />
              <CreditCheckView />
              <OrderView />
              <ViewNavigation />
              <ArchiveReferrer />
              <DemoSwitch />
            </TeamGatekeeper>
          ) : (
            <LoginView />
          )
        }

        <Notification global />
        <DocumentTitle title="Orderportal" />
        <EnvironmentIndicator />
      </div>
    </SalesContext.Provider>
  );
}

export default MainRouter;